import React from "react";
import imgRight from "./img/83EB37A4-BC1A-45A9-B4BB-0A685DDBD989.webp";
import "./style.css";

function HeaderDown({ scrollToComponent }) {
  return (
    <header className="header min-[716px]:flex flex justify-between">
      <section className="pb-8 px-8 lg:w-1/2 lg:text-left flex flex-col justify-around ">
        <h2 className="text-3xl font-bold max-lg:text-center mb-6">
          Көп берилүүчү суроолор
        </h2>
        <div className="space-y-4">
          <div>
            <h3 className="text-2xl font-semibold mb-2">Рассрочка шарттары:</h3>
            <ul className="list-disc text-lg font-semibold list-inside text-gray-900 leading-relaxed">
              <li>Банк аркылуу бөлүп төлөө;</li>
              <li>Паспорт талап кылынат;</li>
              <li>100,000 сомдон жогору сумма үчүн поручитель керек.</li>
            </ul>
          </div>
          <div>
            <h3 className="text-2xl font-semibold mb-2">Дүкөн дареги:</h3>
            <ul className="list-disc list-inside leading-relaxed text-gray-900 text-lg font-semibold">
              <li>Беш-Сары соода борбору, 1-кабат, Бишкек, Кыргызстан.</li>
            </ul>
          </div>
          <div>
            <h3 className="text-2xl font-semibold mb-2">Жеткирүү:</h3>
            <ul className="list-disc text-lg font-semibold list-inside text-gray-900 leading-relaxed">
              <li>Бишкек боюнча жеткирүү бекер.</li>
              <li>Аймактарга жеткирүү кошумча төлөм менен.</li>
            </ul>
          </div>
          <div>
            <h3 className="text-2xl font-semibold mb-2">Заказ берүү:</h3>
            <p className="text-gray-900 leading-relaxed font-semibold text-lg">
              Ватсап аркылуу тандаган столуңуздун жана стулдарыңыздын сүрөтүн
              жиберип коюңуз. Биз баасын эсептеп, төлөмдү кантип жасай
              турганыбызды сүйлөшөбүз.
            </p>
          </div>
        </div>
        <div className="text-center mt-8">
          <button
            onClick={() => window.open("https://wa.me/996707178620", "_blank")}
            className="bg-red-600 hover:bg-red-700 text-white cursor-pointer px-2 sm:px-6 py-3 rounded-lg text-lg font-medium shadow-md transition-all duration-200"
          >
            Бизге байланышып, үйүңүздүн көркүн ачып, көп жылдар бою кызмат
            кылган эмерекке ээ болуңуз!
          </button>
        </div>
      </section>
      <div className="relative top-[1px] lg:flex hidden">
        <img src={imgRight} alt="img" className="w-[500px] h-full cover" />
      </div>
    </header>
  );
}

export default HeaderDown;
